import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { useListIntegrationsQuery } from "@modules/erpIntegrations/services/queries";

const METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE"];

export const EndpointListFilters = React.memo(() => {
  const translate = useTranslate();
  const { data: integrations = [] } = useListIntegrationsQuery({ perPage: 100 });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="integration"
          label={translate("erp_integrations.endpoints.integration")}
          options={[
            { value: "", label: translate("erp_integrations.endpoints.all") },
            ...integrations.map((item) => ({ value: item.id, label: item.name })),
          ]}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("erp_integrations.endpoints.search")}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="method"
          label={translate("erp_integrations.endpoints.method")}
          options={[
            { value: "", label: translate("erp_integrations.endpoints.all") },
            ...METHODS.map((method) => ({ value: method, label: method })),
          ]}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="active"
          label={translate("erp_integrations.endpoints.active")}
          options={[
            { value: "", label: translate("erp_integrations.endpoints.all") },
            { value: "true", label: translate("erp_integrations.endpoints.active_only") },
            { value: "false", label: translate("erp_integrations.endpoints.inactive_only") },
          ]}
        />
      </Grid>
    </Grid>
  );
});
